import { initializeApp } from 'firebase/app';
import {
	getAuth,
	setPersistence,
	browserLocalPersistence,
	connectAuthEmulator,
	getMultiFactorResolver,
	TotpMultiFactorGenerator,
	TotpSecret,
} from 'firebase/auth';

import { handleUnknownError } from '../utils/error_handling';

const firebaseConfig = {
	apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
	authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
	storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
	appId: process.env.REACT_APP_FIREBASE_APP_ID,
	measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

const shouldUseEmulator = process.env.REACT_APP_USE_FIREBASE_EMULATORS === 'true';
const isLocalhost =
	window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';

const USE_AUTH_EMULATOR = shouldUseEmulator && isLocalhost;

try {
	const persistencePromise = setPersistence(auth, browserLocalPersistence);
	if (persistencePromise && typeof persistencePromise.catch === 'function') {
		persistencePromise.catch(error => {
			handleUnknownError(error, { context: 'firebase_persistence' });
		});
	}
} catch (error) {
	handleUnknownError(error, { context: 'firebase_persistence' });
}

if (USE_AUTH_EMULATOR) {
	connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
	// eslint-disable-next-line no-console
	console.warn(
		'🔧 Firebase Auth Emulator is active. Emails will NOT be delivered to real inboxes. ' +
			'Set REACT_APP_USE_FIREBASE_EMULATORS=false to use production Firebase.'
	);
}

export {
	app,
	auth,
	getMultiFactorResolver,
	TotpMultiFactorGenerator,
	TotpSecret,
	USE_AUTH_EMULATOR,
};
